import { createSelector } from '@reduxjs/toolkit';
import { employeesNotDeleted } from '../employees/employees-not-deleted';
import { functionsNotDeleted } from '../responsibilities/functions-not-deleted';
import { employeesShortNames } from '../employees/employees-short-names';
import { tasksNotDeleted } from '../responsibilities/tasks-not-deleted';
import type { EmployeeForStaffingCalendar } from './employee-for-staffing-calendar';
import { displayNameForEmployee } from './display-name-for-employee';
import { EmployeeViewModelStaffGroupEnum } from '@trinnvis/dabih-api-client';
import { isTreatmentProvider } from './is-treatment-provider';
import { isTreatmentHelper } from './is-treatment-helper';
import { LocalDate } from '../../../utilities/local-date';
import { calculateTasksForEmployeeDate } from './calculate-tasks-for-employee-date';
import { _sortEmployees } from './_sort-employees';

export const employeesForStaffingCalendar = createSelector(
  employeesNotDeleted,
  functionsNotDeleted,
  employeesShortNames,
  tasksNotDeleted,
  // TODO  eventsNotDeleted,
  (employees, functions, employeesShortNames, tasks): EmployeeForStaffingCalendar[] => {
    const m = employees
      .filter((e) => {
        return e.isConfirmedEntity;
      })
      .map((e) => {
        return {
          uuid: e.uuid,
          firstName: e.firstName,
          lastName: e.lastName,
          name: e.name,
          displayName: displayNameForEmployee(employeesShortNames, e),
          staffGroup: e.staffGroup || EmployeeViewModelStaffGroupEnum.G1,
          treatmentProvider: isTreatmentProvider(e, functions),
          treatmentHelper: isTreatmentHelper(e, functions),
          workSchedules: e.workSchedules,
          workScheduleExceptions: e.workScheduleExceptions,
          leavePeriods: e.leavePeriods,
          plusTimePeriods: e.plusTimePeriods,
          timekeepingCorrections: e.timekeepingCorrections,
          gender: e.gender,
          employmentStartDate: e.employmentStartDate,
          employmentEndDate: e.employmentEndDate,
          tasksLookup: (date: string) => {
            const d = LocalDate.fromString(date);
            return calculateTasksForEmployeeDate(e, d, functions, tasks);
          },
        };
      });

    return _sortEmployees(m, true);
  },
);
